import React from "react";
import { Grid, MenuItem, CircularProgress, Card } from "@mui/material";
import { useFormikContext } from "formik";
import MDBox from "components/MDBox";
import FormField from "components/FormField";
import { useGetFundamentosLegalesQuery } from "services/escuela/nomencladores/fundamento_legal.service";
import { useGetMotivosCancelacionQuery } from "services/escuela/nomencladores/motivos_cancelacion.service";
import { useGetReconocimientosQuery } from "services/escuela/nomencladores/reconocimiento.service";
import SelectFirmante from "./SelectFirmante";

const OtrosTab = () => {
  const { values, errors, touched, handleChange } =
    useFormikContext();

  const { data: fundamentosData, isLoading: isLoadingFundamentos } =
    useGetFundamentosLegalesQuery();
  const fundamentos = fundamentosData?.results || fundamentosData || [];

  const { data: reconocimientosData, isLoading: isLoadingReconocimientos } =
    useGetReconocimientosQuery();
  const reconocimientos =
    reconocimientosData?.results || reconocimientosData || [];

  const { data: motivosData, isLoading: isLoadingMotivos } =
    useGetMotivosCancelacionQuery();
  const motivos = motivosData?.results || motivosData || [];

  return (
    <MDBox mt={2}>
      <Card sx={{ overflow: "visible", padding: 2 }}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <FormField
              select
              label="Fundamento Legal"
              name="fundamento_legal"
              value={values.fundamento_legal}
              onChange={handleChange}
              error={errors.fundamento_legal && touched.fundamento_legal}
              disabled={isLoadingFundamentos}
            >
              <MenuItem value="">
                <em>Seleccione una opción</em>
              </MenuItem>
              {isLoadingFundamentos ? (
                <MenuItem disabled>
                  <CircularProgress size={20} />
                </MenuItem>
              ) : (
                fundamentos.map((item) => (
                  <MenuItem key={item.id} value={item.url}>
                    {item.descripcion}
                  </MenuItem>
                ))
              )}
            </FormField>
          </Grid>

          <Grid item xs={12}>
            <FormField
              select
              label="Reconocimiento"
              name="reconocimiento"
              value={values.reconocimiento}
              onChange={handleChange}
              error={errors.reconocimiento && touched.reconocimiento}
              disabled={isLoadingReconocimientos}
            >
              <MenuItem value="">
                <em>Seleccione una opción</em>
              </MenuItem>
              {isLoadingReconocimientos ? (
                <MenuItem disabled>
                  <CircularProgress size={20} />
                </MenuItem>
              ) : (
                reconocimientos.map((item) => (
                  <MenuItem key={item.id} value={item.url}>
                    {item.descripcion}
                  </MenuItem>
                ))
              )}
            </FormField>
          </Grid>

          <Grid item xs={12}>
            <FormField
              select
              label="Motivo de Cancelación"
              name="motivo_cancelacion"
              value={values.motivo_cancelacion}
              onChange={handleChange}
              error={errors.motivo_cancelacion && touched.motivo_cancelacion}
              disabled={isLoadingMotivos}
            >
              <MenuItem value="">
                <em>Ninguno</em>
              </MenuItem>
              {isLoadingMotivos ? (
                <MenuItem disabled>
                  <CircularProgress size={20} />
                </MenuItem>
              ) : (
                motivos.map((item) => (
                  <MenuItem key={item.id} value={item.url}>
                    {item.descripcion}
                  </MenuItem>
                ))
              )}
            </FormField>
          </Grid>

          <Grid item xs={12}>
            <SelectFirmante />
          </Grid>
        </Grid>
      </Card>
    </MDBox>
  );
};

export default OtrosTab;
